import { userReducer } from "./user.reducer";
import { companyReducer } from "./company.reducer";
import { recruiterReducer } from "./recruiter.reducer";
import { candidateReducer } from "./candidate.reducer";
import { projectReducer } from "./project.reducer";
import { activityReducer } from "./activity.reducer";
import { spinnerReducer } from "./spinner.reducer";
import { dashboardReducer } from "./dashboard.reducer";
import { screenReducer } from "./screen.reducer";

//Exporting reducers for other redux
const allReducers = {
  userReducer,
  companyReducer,
  recruiterReducer,
  candidateReducer,
  projectReducer,
  activityReducer,
  spinnerReducer,
  dashboardReducer,
  screenReducer
};

export default allReducers;
